import './index.scss';

import React, { useEffect, useState } from 'react';

import BR from '../../assets/icons/country-flag/brazil.svg';
import EUA from '../../assets/icons/country-flag/united-states.svg';
import EUR from '../../assets/icons/country-flag/european-union.svg';
import GBP from '../../assets/icons/country-flag/united-kingdom.svg';
import CAD from '../../assets/icons/country-flag/canada.svg';
import AUD from '../../assets/icons/country-flag/australia.svg';


import { RiArrowDropDownLine } from "react-icons/ri";
import Select from 'react-select';
import { Switch } from '../../components/switch';
import { FormInput } from '../abertura-de-conta/components/form-input';
import { cpfValidator, requiredValidator, sizeValidator } from '../../utils/validators';
import { cellMask, cpfMask, letraMask } from '../../utils/masks';
import { Icon } from '../../components/icon';

import Loading from "../../assets/icons/loading.svg"
import { CurrencyFormatter } from '../../utils/formatter';


const senderOptions = [
    { value: 'brl', label: <div style={{display:"flex", alignItems:"center"}}><img src={BR} alt="BR" style={{ width: '20px', marginRight: '10px' }} />BRL (Real)</div> },
];

const receiverOptions = [
    { value: 'usd', label: <div style={{display:"flex", alignItems:"center"}}><img src={EUA} alt="US" style={{ width: '20px', marginRight: '10px' }} />USD (Dólar)</div> },
    { value: 'eur', label: <div style={{display:"flex", alignItems:"center"}}><img src={EUR} alt="EU" style={{ width: '20px', marginRight: '10px' }} />EUR (Euro)</div> },
    { value: 'gbp', label: <div style={{display:"flex", alignItems:"center"}}><img src={GBP} alt="US" style={{ width: '20px', marginRight: '10px' }} />GBP (Libra Esterlina)</div> },
    { value: 'cad', label: <div style={{display:"flex", alignItems:"center"}}><img src={CAD} alt="CA" style={{ width: '20px', marginRight: '10px' }} />CAD (Dólar Canadense)</div> },
    { value: 'aud', label: <div style={{display:"flex", alignItems:"center"}}><img src={AUD} alt="AU" style={{ width: '20px', marginRight: '10px' }} />AUD (Dólar Australiano)</div> },
];

export const SimuleSuaRemessa = () => {

    const [selectedCurrencySender, setSelectedCurrencySender] = useState(senderOptions[0]);
    const [selectedCurrencyReceiver, setSelectedCurrencyReceiver] = useState(receiverOptions[0]);

    const [cambioValue,setDolarValue] = useState(6.00)
    const [sentCurrency,setSentCurrency] = useState('1000');
    const [receivedCurrency,setReceivedCurrency] = useState('0')
    const [iof,setIof] = useState(38) 
    const [taxaCobaltPaga,setTaxaCobalt] = useState(0)
    const taxaCobalt = 0
    const [remessa,setRemessa] = useState("1.000,00")
    const [total,SetTotal] = useState(100)

    const handleChangeSender = (selectedOption) => {
        setSelectedCurrencySender(selectedOption);
    };

    const handleChangeReceiver = (selectedOption) => {
        setSelectedCurrencyReceiver(selectedOption);
    };
    const [actVal, setActVal] = useState("1.000,00")
    const maskRemessa = (e,isSent)=>{
        const normalizedVal = e.target.value.trim().replace(".","").replace(",",".")
        const value = normalizedVal.split(".")
        let whole = parseFloat(value[0]?.replace(/[^0-9]+/g, "")).toLocaleString("pt-br", {minimumFractionDigits:0})
        let decimal = parseInt(value[1]?.replace(/[^0-9]+/g, ""))
        if(isNaN(whole)){setActVal(""); return}
        setActVal(whole + (isNaN(decimal)? 
        (normalizedVal.includes(".")? "," : "") 
        : 
        ("," + decimal) ))
        if(isSent){
            setSentCurrency(e.target.value.replace(".","").replace(",","."))

        }
        else{
            setReceivedCurrency(e.target.value.replace(".","").replace(",","."))
        }
    }
    function GetData(){
        fetch(process.env.REACT_APP_API_URL+`Get_Price?from=${selectedCurrencySender.value.toUpperCase()}&to=${selectedCurrencyReceiver.value.toUpperCase()}&value=${sentCurrency}`,
            {
                headers: {
                },
                method: "GET",
            })
            .then((response)=>{ 
                response.json().then((json)=>{
                    if(json.hasError===false){
                        let remessaValor;
                        setReceivedCurrency(new Intl.NumberFormat('pt-BR').format(json.model.price))
                        setDolarValue(json.model.quotation)

                        if(selectedCurrencySender.value=="brl"){
                            remessaValor=json.model.valueReceived
                            setRemessa(new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(remessaValor))
                        }
                        else{
                                remessaValor=json.model.price
                                setRemessa(new Intl.NumberFormat('pt-BR',{ style: 'currency', currency: 'BRL' }).format(remessaValor))
                        }
                        const iof=((json.model.iofPercentage*remessaValor)/100)
                        const taxaAPagar= (taxaCobalt*remessaValor)
                        setIof(iof.toFixed(2))
                        setTaxaCobalt(taxaAPagar.toFixed(2))
                        const total= iof+taxaAPagar+Number(remessaValor)
                        SetTotal(new Intl.NumberFormat('pt-BR',{ style: 'currency', currency: 'BRL' }).format(total))
                    }
                    })
        })
        
    }

    const [isJuridico, setIsJuridico] = useState(true)

    const [pix, setPix] = useState(false)
    const [isValid, setIsValid] = useState(false)

    const [loadingSend, setLoadingSend] = useState(false);

    const registerPix = async (e) => {
        e.preventDefault();
        const form = e.target
        if(isValid){
            setLoadingSend(true)
            var data= JSON.stringify(
                {
                    "id_usuario":0,
                    "nm_usuario": form.nomecompleto.value,
                    "cd_cpf": form.cpf.value.replace("-", "").replace(".", ""),
                    "nu_cel": form.celular.value,
                    "cd_forma_de_cadastro": 1
                    
                  }
            )
            const vc = sentCurrency.split(".")
            const whole = vc[0]
            const digit = vc[1] !== undefined && vc[1].length > 0 ? vc[1] : "00"

            console.log(whole+digit)

            fetch(process.env.REACT_APP_API_URL+'Register_PF',
                {
                    headers: {
                      'Accept': 'application/json',
                      'Content-Type': 'application/json'
                    },
                    method: "POST",
                    body: data
                })
                .then((response)=>{ 
                    response.json().then((json)=>{
                        console.log(json)
                        if(json.hasError===false || json.description === "Usuário já cadastrado") 

                            window.open(`https://iamsimple.com.br/COBALT/?simulator=remittance&receivePurposeCode=MAINTENANCE&currencyCode=${selectedCurrencyReceiver.value.toUpperCase()}&remittanceType=OUTBOUND&remittanceAmount=${whole}${digit}&reverse=true`)
                            setPix(false)
                        })
    
                }).finally(()=>{setLoadingSend(false);})
    
        }
    }

    const [inputState, setInputState] = useState(
        {
            nomecompleto: false,
            cpf: false,
            celular: false,
           
        })

    const updateField = (field, state) => {
        setInputState(oldState => {
            const ccpy = { ...oldState }
            ccpy[field] = state;
            return { ...ccpy }
        })
    }

    useEffect(() => {
        setIsValid(true);
        for (const v of Object.values(inputState)) {
            if (v === false) {
                setIsValid(false);
                break;
            }
        }
    }, [inputState])


    useEffect(() => {
       GetData()
    }, [selectedCurrencyReceiver])

    return (

        <div className='container-page2'>

            <div className='title-page2'> Simule sua remessa </div>
            { pix? 
            <form className='container1-page2' onSubmit={registerPix}>
                <div className='sub-container2-page2 cadastro-container' >
                {loadingSend ? 
                    <div style={{display:"flex", flexDirection:"column", gap:20, alignItems:"center"}}> 
                        <Icon icon={Loading} size={80}/>
                        <p style={{
                            fontSize:"1.112rem"
                        }}>Redirecionando para nossa plataforma</p>
                    </div> 
                    : 
                    <>
                        <div className='cadastro-title' > Faça seu cadastro para concluir </div>
                        <div className='cadastro-row'>
                            <FormInput label="Nome completo"
                                messageStyle={{fontSize:"1.125em", fontWeight:800}}                             
                                colStyle={{gap:16, flexBasis: "35.5%" }}
                                labelStyle={{color:"white", fontSize:"1em"}} 
                                style={{fontSize:18, padding:"0px 10px", borderRadius:"4px"}}
                                className="cadastro-input"
                                id="nomecompleto"
                                validators={[{ func: requiredValidator}]}
                                mask={letraMask}
                                updateField={updateField}/>
                            
                            <FormInput 
                                messageStyle={{fontSize:"1.125em", fontWeight:800}}                             
                                id="cpf" label={"CPF"}
                                validators={[{ func: requiredValidator, cpfValidator}]}
                                mask={cpfMask}
                                updateField={updateField} 
                                colStyle={{gap:16, minWidth: '200px'}}
                                labelStyle={{color:"white", fontSize:"1em"}}
                                style={{fontSize:18, padding:"0px 10px", borderRadius:"4px"}}
                                className="cadastro-input"
                                />

                            <FormInput id="celular" 
                                messageStyle={{fontSize:"1.125em", fontWeight:800}} 
                                colStyle={{gap:16, minWidth: '200px'}}
                                labelStyle={{color:"white", fontSize:"1em"}} 
                                style={{fontSize:18, padding:"0px 10px", borderRadius:"4px"}}
                                className="cadastro-input"
                                label={"Celular"}
                                placeholder="(XX) XXXXX-XXXX"
                                validators={[{ func: requiredValidator, sizeValidator,argument:15  }]}
                                mask={cellMask}
                                updateField={updateField}
                            />

                        </div>
                        
                        <button className='btn-remessa' type="submit" disabled={!isValid}>Concluir</button>
                    </>
                }
                </div>
            </form>
            :
            <div className='container1-page2' >

                <div className='sub-container1-page2'>

                    <div style={{ display: "flex ", gap: "12px", marginBottom:"24px"}}>
                    <Switch value={isJuridico} 
                        onChange={() => {setIsJuridico(!isJuridico)}}
                    />
                        <div className='text-subcontainer-page2'> Sou pessoa {isJuridico? "jurídica" : "física"} </div>
                    </div>

                    <div style={{display:"flex", flexDirection:"column", gap:"12px",  marginBottom:"24px"}}>
                        <div className='text-subcontainer-page2'> Você envia </div>

                        <div className='container-cotacao1-page2'>
                            <div className='select-holder'>
                            <Select
                                options={senderOptions}
                                value={selectedCurrencySender}
                                onChange={handleChangeSender}
                                components={{
                                    DropdownIndicator: (props) => (
                                        <RiArrowDropDownLine {...props.innerProps} style={{
                                            color: '#0f0f0f',
                                        }} size={35}/>
                                    ),
                                }}
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        width:"100%",
                                        minWidth:"100%",
                                        border: '1px solid #ccc',
                                        color: '#0f0f0f',
                                        borderRadius: '4px',
                                        boxShadow: '5px 0 5px rgba(0, 0, 0, 0.22)',
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        color: '#0f0f0f !important',
                                        fontSize:"14px",
                                    }),
                                }}

                            />
                            </div>
                            <div className='coins-cotacao'>
                                <span style={{
                                    color: '#191515', fontWeight: 500,
                                    fontSize: '18px'
                                }}>{selectedCurrencySender.value === "brl" ? "R$" : "U$"} </span>
                                <input value={actVal}  className='remessa-input' placeholder='0,00' onChange={(e)=>{maskRemessa(e,true);}} onBlur={()=>GetData()}/>
                            </div>
                        </div>
                    </div>
                    
                    <div style={{display:"flex", flexDirection:"column", gap:"12px"}}>
                        <div className='text-subcontainer-page2'> O beneficiário recebe </div>

                        <div className='container-cotacao1-page2'>
                            <div className='select-holder'>
                            <Select
                                options={receiverOptions}
                                value={selectedCurrencyReceiver}
                                onChange={handleChangeReceiver}
                                components={{
                                    DropdownIndicator: (props) => (
                                        <RiArrowDropDownLine {...props.innerProps} style={{
                                            color: '#0f0f0f',
                                        }} size={35}/>
                                    ),
                                }}
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        width:"100%",
                                        minWidth:"100%",
                                        border: '1px solid #ccc',
                                        color: '#0f0f0f',
                                        borderRadius: '4px',
                                        boxShadow: '5px 0 5px rgba(0, 0, 0, 0.22)',
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        color: '#0f0f0f !important',
                                        fontSize:"14px",
                                        width:"250px"
                                    }),
                                }}
                            />
                            </div>
                            <div className='coins-cotacao'>
                                <span style={{
                                    color: '#191515', fontWeight: 500,
                                    fontSize: '18px'
                                }}>{selectedCurrencyReceiver.value === "brl" ? "R$" : "U$"} </span>
                                <h2 style={{ all: 'unset' }}> {parseFloat(receivedCurrency?.replace(".","").replace(",",".")).toLocaleString("pt-br", {maximumFractionDigits:2,minimumFractionDigits:2})} </h2>
                            </div>
                        </div>
                    </div>

                </div>

                <div className='sub-container2-page2'>
                    <div className='text-subcontainer-page2'> 1 {selectedCurrencyReceiver.value.toUpperCase()} = {cambioValue} BRL </div>

                    <div className='container-central-subpage2-page2'>
                        <div className='box-remessa'>
                            <div className='box-title'> Remessa </div>
                            <div className='box-value'> {remessa} </div>
                        </div>

                        <div className='box-iof'>
                            <div  className='box-pair'>
                                <div className='box-title'> IOF </div>
                                <div className='box-value' style={{fontSize:18, fontWeight:500}}> {CurrencyFormatter(iof)} </div>
                            </div>

                            <span className='separate'> </span>

                            <div className='box-pair'>
                                <div className='box-title'> Taxa Cobalt </div>
                                <div className='box-value'> ZERO </div>
                            </div>
                        </div>

                        <div className='box-total'>
                            <div className='box-title' style={{textAlign:"right"}}> Total a pagar </div>
                            <div className='box-value'> {total} </div>
                        </div>
                    </div>

                    <div style={{
                        marginTop:isJuridico?"15px":"",
                        marginBottom:isJuridico?"14px":""
                        }}>
                        {isJuridico? 
                            <a className='btn-remessa-small' href='https://wa.me/5511973667387' target="_blank" rel="noopener noreferrer" > Fale com um especialista </a>
                            :
                            <button className='btn-remessa-small' onClick={() => setPix(true)}> Concluir com PIX </button>
                        }
                    </div>

                </div>

            </div>
            }

        </div>

    )

}

                        